import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  canAccessContractorAssistedRegistration,
  canAccessContractorPortal,
  canAccessMarketGrowthAdmin,
  canAccessPartnerPortal,
  canManageContractorTeam,
} from "../../utils/authRoleHelpers";

const RoleGuardRoute = ({
  children,
  requireAdmin = false,
  requirePartner = false,
  requireContractor = false,
  requireContractorPrimary = false,
  requireContractorAssistedRegistration = false,
}) => {
  const location = useLocation();

  if (requireAdmin && !canAccessMarketGrowthAdmin()) {
    return (
      <Navigate
        to="/403"
        replace
        state={{
          from: location,
          message: "شما به این بخش دسترسی ندارید.",
        }}
      />
    );
  }

  if (requirePartner && !canAccessPartnerPortal()) {
    return (
      <Navigate
        to="/403"
        replace
        state={{
          from: location,
          message: "پنل نماینده فقط برای کاربران دارای پروفایل نمایندگی فعال است.",
        }}
      />
    );
  }

  if (requireContractor && !canAccessContractorPortal()) {
    return (
      <Navigate
        to="/403"
        replace
        state={{
          from: location,
          message: "پورتال پیمانکار فقط برای حساب پیمانکار در دسترس است.",
        }}
      />
    );
  }

  if (requireContractorPrimary && !canManageContractorTeam()) {
    return (
      <Navigate
        to="/403"
        replace
        state={{
          from: location,
          message: "این بخش فقط برای حساب اصلی پیمانکار در دسترس است.",
        }}
      />
    );
  }

  if (
    requireContractorAssistedRegistration &&
    !canAccessContractorAssistedRegistration()
  ) {
    return (
      <Navigate
        to="/403"
        replace
        state={{
          from: location,
          message: "دسترسی ثبت متقاضی برای این حساب فعال نیست.",
        }}
      />
    );
  }

  return children;
};

export default RoleGuardRoute;
